// GET_SUPPORT_CONVERSATIONS
export const GET_SUPPORT_CONVERSATIONS = "GET_SUPPORT_CONVERSATIONS";

// GET_SUPPORT_CONVERSATION_DETAILS
export const GET_SUPPORT_CONVERSATION_DETAILS = "GET_SUPPORT_CONVERSATION_DETAILS";

// UPDATE_SUPPORT_STATUS
export const UPDATE_SUPPORT_STATUS = "UPDATE_SUPPORT_STATUS";

// UPDATE_SUPPORT_PRIORITY
export const UPDATE_SUPPORT_PRIORITY = "UPDATE_SUPPORT_PRIORITY";

// ASSIGN_AGENT
export const ASSIGN_AGENT = "ASSIGN_AGENT";

// SEND_SUPPORT_MESSAGE
export const SEND_SUPPORT_MESSAGE = "SEND_SUPPORT_MESSAGE";

// DELETE_SUPPORT_MESSAGE
export const DELETE_SUPPORT_MESSAGE = "DELETE_SUPPORT_MESSAGE";

// GET_SUPPORT_STATS
export const GET_SUPPORT_STATS = "GET_SUPPORT_STATS";

// CLEAR_SUPPORT_CONVERSATION_DETAILS
export const CLEAR_SUPPORT_CONVERSATION_DETAILS = "CLEAR_SUPPORT_CONVERSATION_DETAILS";

// ADD_INTERNAL_NOTE
export const ADD_INTERNAL_NOTE = "ADD_INTERNAL_NOTE";

// MARK_SUPPORT_READ
export const MARK_SUPPORT_READ = "MARK_SUPPORT_READ";

// RECEIVE_SUPPORT_MESSAGE_VIA_SOCKET (for real-time messages)
export const RECEIVE_SUPPORT_MESSAGE_VIA_SOCKET = "RECEIVE_SUPPORT_MESSAGE_VIA_SOCKET";

// SET_USER_TYPING
export const SET_USER_TYPING = "SET_USER_TYPING";

// CREATE_SUPPORT_CONVERSATION
export const CREATE_SUPPORT_CONVERSATION = "CREATE_SUPPORT_CONVERSATION";
